/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Unknown
 *
 * 1 = Lead
 *
 * 2 = Pss
 *
 * 3 = SvcEval
 *
 * 4 = SvcProsp
 *
 * 5 = SendManagerAppraisalLinkToCustomer
 *
 * 6 = SendAppointmentConfirmation
 *
 * 7 = SendHandoverConfirmation
 *
 * 8 = WebClientUserSendTo
 *
 * 9 = WebClientUserReceivedTo
 *
 * 10 = DealSendOffer
 *
 * 11 = AutomotiveEnquirySendDDI
 *
 * 12 = CheckInNotification
 *
 * 13 = VipPhonecall
 *
 * 99 = Free
 *
 * 100 = ServiceBooking
 *
 * 101 = SalesOffer
 *
 * 103 = PartRequest
 *
 * 104 = PartRequestFrom
 *
 * 105 = PartsDiscrepancies
 *
 * 106 = EnquiryCrm
 *
 * 107 = Appraisal
 *
 * 108 = EDocument
 *
 * 109 = HandoverFollowUp
 *
 * 110 = PurchaseOrderLog
 *
 * 111 = Reservation
 *
 * 112 = PaymentRequest
 *
 * 113 = ServicePlanQuote
 *
 * 114 = Sorder
 *
 * 115 = AuctionCarLog
 *
 * 116 = InternalDialog
 *
 * 117 = UserCandidateDetails
 *
 * 119 = SoHeaderSend
 *
 * 120 = SoHeaderReceived
 *
 * 121 = ServicePlanEmails
 *
 * 123 = WebclientAppraisal
 *
 * 124 = All
 */
export enum EmailTaskEnum {
  Unknown = 0,
  Lead = 1,
  Pss = 2,
  SvcEval = 3,
  SvcProsp = 4,
  SendManagerAppraisalLinkToCustomer = 5,
  SendAppointmentConfirmation = 6,
  SendHandoverConfirmation = 7,
  WebClientUserSendTo = 8,
  WebClientUserReceivedTo = 9,
  DealSendOffer = 10,
  AutomotiveEnquirySendDDI = 11,
  CheckInNotification = 12,
  VipPhonecall = 13,
  Free = 99,
  ServiceBooking = 100,
  SalesOffer = 101,
  PartRequest = 103,
  PartRequestFrom = 104,
  PartsDiscrepancies = 105,
  EnquiryCrm = 106,
  Appraisal = 107,
  EDocument = 108,
  HandoverFollowUp = 109,
  PurchaseOrderLog = 110,
  Reservation = 111,
  PaymentRequest = 112,
  ServicePlanQuote = 113,
  Sorder = 114,
  AuctionCarLog = 115,
  InternalDialog = 116,
  UserCandidateDetails = 117,
  SoHeaderSend = 119,
  SoHeaderReceived = 120,
  ServicePlanEmails = 121,
  WebclientAppraisal = 123,
  All = 124,
}
